export default __webpack_public_path__ + "static/media/vol_on_tooltip.5479192e.svg";